import React from 'react'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home"
import Design from "./pages/Design"
import Signin from "./pages/Signin"
import { Header } from "./components/Header";
import Qrcode from "./pages/Qrcode";
import {ProductDetails} from './pages/product'
import { Addfabric } from "./pages/Addfabric";
import {FabricGallery} from  "./pages/FabricGallery";
import {Merchant} from "./pages/Merchant";
import { MerchantGallery } from "./pages/MerchantGallery";
import PrintCom from "./pages/PrintCom";
import { AddApparel } from './pages/product';
import ForgotPassword from './pages/ForgotPassword';
import ChangePassword from './pages/ChangePassword';
import Signup from './pages/Signup';
import LandingPage from './pages/LandingPage';
import Mens from './pages/Mens';
import CategoryPage from './pages/CategoryPage';
import GenderCategoryPage from './pages/GenderCategory';
import EditApparel from './pages/EditApparel';
import "./App.css"
import ProductDetailsPopup from './pages/product/ProductDetailsPopup';
import ProductDetailsPage from './pages/product/ProductDetailsPage';
import SearchResultsPage from './pages/SearchResultsPage';
import Adminsignin from './pages/admin_module/Adminsignin';
import Adminsignup from './pages/admin_module/Adminsignup';
import Adminforgotpassword from './pages/admin_module/Adminforgotpassword';
import AdminDashboard from './pages/admin_module/AdminDashboard';
import PrivateRoute from './components/PrivateRoute';

function App() {

  return (
    <>
    <Router>
      {/* <div className='flex flex-col'>
  <Header/> */}
      <Routes>

{/* <---------------------------------------User Routes for Men, Women and Kids Wear----------------------------------> */}
     
        <Route path="/" element={<Signin/>} />
        <Route path="/Home" element={<PrivateRoute><Home/></PrivateRoute>} />
        <Route path='/LandingPage' element={<PrivateRoute><LandingPage/></PrivateRoute>} />
        <Route path="/category/:category" element={<PrivateRoute><CategoryPage /></PrivateRoute>} />
        <Route path="/category/:category/:subCategory" element={<PrivateRoute><GenderCategoryPage /></PrivateRoute>} />
        <Route path="/product/:uniqueId" element={<PrivateRoute><ProductDetailsPage /></PrivateRoute>} />
        <Route path="/search/:query" element={<PrivateRoute><SearchResultsPage /></PrivateRoute>} />
        <Route path='/Mens' element={<PrivateRoute><Mens/></PrivateRoute>} />
        <Route path="/Forgotpassword" element={<ForgotPassword/>} />
        <Route path="/Changepassword" element={<ChangePassword/>} />
        <Route path="/Signup" element={<Signup/>} /> 
        <Route path="/AddApparel" element={<PrivateRoute><AddApparel/></PrivateRoute>} />
        <Route path="/EditApparel/:id" element={<PrivateRoute><EditApparel/></PrivateRoute>} />
        <Route path="/Design" element={<PrivateRoute><Design/></PrivateRoute>} />
        <Route path="/Qrcode" element={<PrivateRoute><Qrcode/></PrivateRoute>} />
        <Route path="/products/:productId" element={<PrivateRoute><ProductDetails /></PrivateRoute>} />

{/* <----------------------------------------Admin Routes-------------------------------------------------->  */}

        <Route path="/admin/Adminsignin" element={<Adminsignin />} />
        <Route path="/admin/Adminsignup" element={<Adminsignup/>} />
        <Route path="/admin/Adminforgotpassword" element={<Adminforgotpassword />} />
        <Route path="/admin/AdminDashboard" element={<PrivateRoute><AdminDashboard/></PrivateRoute>} />

        
        {/* <Route path="/ProductDetails" element={<ProductDetails/>} /> */}
        <Route path="/Addfabric" element={<PrivateRoute><Addfabric/></PrivateRoute>} />
        <Route path="/FabricGallery" element={<PrivateRoute><FabricGallery/></PrivateRoute>} />
        <Route path="/Merchant" element={<PrivateRoute><Merchant/></PrivateRoute>} />
        <Route path="/MerchantGallery" element={<PrivateRoute><MerchantGallery/></PrivateRoute>} />
        <Route path="/PrintCom" element={<PrivateRoute><PrintCom/></PrivateRoute>} />
      </Routes>
      {/* </div> */}
    </Router>
    </>
  );
}

export default App;
